import { Injectable, signal } from '@angular/core';

@Injectable()
export class EvaluationPanelStateService {
  public readonly isExpanded = signal(true);
  public readonly isFullScreen = signal(false);

  public toggleExpanded(): void {
    this.isExpanded.update(value => !value);
    this.isFullScreen.set(false);
  }

  public toggleFullScreen(): void {
    this.isFullScreen.update(value => !value);
    this.isExpanded.set(true);
  }
}
